import ChoiceEcho from '../echo_components/choice/choice_echo.vue';

import DetermineEcho from '../echo_components/determine/determine_echo.vue';

import FillingBlanksEcho from '../echo_components/fillingBlanks/fillingBlanks_echo.vue';
import FillMatrix from '../echo_components/fillingBlanks/matrim_fill.vue';

import SumEcho from '../echo_components/sum/sum_echo.vue'

import ImgDragEcho from '../echo_components/imgDrag/imgDrag_echo.vue'

import TextDragEcho from '../echo_components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from '../echo_components/textDrag/textDrag_echo_2.vue'

import LigatureEcho from '../echo_components/ligature/ligature_echo.vue'

import HotspotEcho from '../echo_components/hotspot/hotspot_echo.vue'

export default {
  ChoiceEcho,

  DetermineEcho,

  FillingBlanksEcho,

  FillMatrix,

  SumEcho,

  ImgDragEcho,

  TextDragEcho,

  TextDragEcho2,

  LigatureEcho,

  HotspotEcho,
}